import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { UsersComponent } from './users.component';

@NgModule({
  declarations: [UsersComponent],
  imports: [
    CommonModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    RadioButtonModule,
    InputNumberModule,
    ButtonModule,
    RippleModule,
    RatingModule,
    TableModule,
    FileUploadModule,
    ToolbarModule,
    ToastModule,
    ReactiveFormsModule,
    InputSwitchModule,
    BadgeModule,
    TranslateModule
  ],
  exports: [UsersComponent],
  providers: [MessageService]
})
export class UsersModule {}
